/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './video-stream.stache';
import deviceUtil from 'scripts/utils/device';
import Swiper from 'swiper';
import {Playlist, videoHubUrl} from 'scripts/utils/playlist';
import dtm from 'scripts/services/dtm';
import urlUtil from 'scripts/utils/url';

Component.extend({
    tag: 'video-stream',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            activePlaylist: {
                Type: Playlist,
                Value: Playlist
            },
            videoCarouselPlaylist: {
                Type: Playlist,
                Value: Playlist
            },
            playAll: {
                type: 'boolean',
                Value: false
            },
            dtmTrack: {
                type: 'boolean'
            },
            dtmVideoLocation: {
                type: 'string'
            }
        },
        onVideoReady(event) {
            const pageTitle = _.get(event, 'data.name', '');
            const videoId = _.get(event, 'data.id', '');
            const video = this.activePlaylist.activeVideo;

            if (videoId !== video.brightcoveId) {
                return;
            }

            if (!video.attr('pageTitle') && pageTitle) {
                video.attr('pageTitle', pageTitle);
                document.title = pageTitle;
                urlUtil.replaceState(`${videoHubUrl}#brightcoveId=${video.brightcoveId}&pageTitle=${encodeURIComponent(pageTitle)}&playlist=${this.activePlaylist.type}`);
            }
        },
        playNextVideo () {
            dtm.trackVideoDetailVideoComplete();
            this.activePlaylist.nextVideo()
                .done(() => {
                    if (!deviceUtil.isMobile) {
                        dtm.trackVideoDetailAutoPlay();
                    }
                })
                .fail(() => {
                    const allPlaylists = this.attr('allPlaylists');
                    const currentPlaylistIndex = (() => {
                        const activePlaylist = this.attr('activePlaylist');
                        for (let i = 0; i < allPlaylists.length; i++) {
                            const playlist = allPlaylists[i];
                            if (playlist === activePlaylist) {
                                return i;
                            }
                        }
                    })();
                    if (currentPlaylistIndex != null) {
                        const newPlaylist = allPlaylists.attr(currentPlaylistIndex + 1);
                        if (newPlaylist && newPlaylist.videos.length) {
                            this.attr('activePlaylist', newPlaylist);
                            newPlaylist.setVideo(0);

                            if (!deviceUtil.isMobile) {
                                dtm.trackVideoDetailAutoPlay();
                            }
                        }
                    }
                });
        }
    },
    init () {
        this.viewModel.attr('isMobile', deviceUtil.isMobile);

        if (!deviceUtil.isMobile) {
            dtm.trackVideoDetailAutoPlay();
        }
    },
    events: {
        inserted: function () {

            let self = this;

            this.$videoCarouselContainer = $(this.element).find('.s-video-carousel');
            this.swiper = new Swiper(this.$videoCarouselContainer.find('.swiper-container'), {
                effect: 'fade',
                simulateTouch: false,
                paginationClickable: true,
                speed: 500,
                pagination: {
                    el: this.$videoCarouselContainer.find('.swiper-pagination'),
                    clickable: true,
                    renderBullet: function (index, className) {
                        const video = self.viewModel.attr('videoCarouselPlaylist').videos[index];
                        const label = video.paginationLabel ? video.paginationLabel : video.label;
                        return '<span class="' + className + '">' + label + '</span>';
                    }
                }
            });
        },

        '.js-video-preview__img-box click' (event) {
            const targetIndex = $(event.context).data('index');
            this.viewModel.attr('videoCarouselPlaylist').setVideo(targetIndex);

            this.viewModel.attr('dtmTrack', true);
        }
    }
});
